import { render } from "./AuthenticateIdentityToken.vue?vue&type=template&id=4e6e553c"
import script from "./AuthenticateIdentityToken.vue?vue&type=script&lang=js"
export * from "./AuthenticateIdentityToken.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__